module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020.df370e46.mp4";